<template>
    <div class="loading-box" v-show="visible">
        <img src="~@img/loading-2.gif" alt="加载中...">
    </div>
</template>

<script>
export default {
    data: function () {
        return {

        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../scss/common/loading.scss';
</style>



// WEBPACK FOOTER //
// src/components/lib/loading.vue